import { Button, Group } from '@mantine/core';
import { FiCheckCircle, FiEdit, FiTrash2 } from 'react-icons/fi';
import ShareJobButton from './ShareJobButton';

interface JobActionsBarProps {
  completeJobHref: string;
  editQuestionsHref: string;
  onDeleteJob: () => void;
  onShareJob: () => void;
}

// For desktop layout
export default function JobActionsBar({
  completeJobHref,
  editQuestionsHref,
  onDeleteJob,
  onShareJob,
}: JobActionsBarProps) {
  return (
    <Group wrap="nowrap" justify="space-between">
      <Button
        component="a"
        href={completeJobHref}
        variant="transparent"
        leftSection={<FiCheckCircle size={20} />}
        c="black"
        fw={700}
        size="xs"
        p={0}
      >
        Edit job
      </Button>

      <Button
        component="a"
        href={editQuestionsHref}
        variant="transparent"
        leftSection={<FiEdit size={20} />}
        c="black"
        fw={700}
        size="xs"
        p={0}
      >
        Edit questions
      </Button>

      <Button
        variant="transparent"
        leftSection={<FiTrash2 size={20} />}
        c="black"
        fw={700}
        onClick={onDeleteJob}
        size="xs"
        p={0}
      >
        Delete job
      </Button>

      <ShareJobButton onShareJob={onShareJob} />
    </Group>
  );
}
